import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeUOMCreate,
  detail: routeUOMDetail,
  home: routeUOMHome,
  root: routeUOMRoot,
} = createDoctypeRoutes({
  createName: 'new-uom',
  createPath: 'new-uom',
  detailName: 'uomDetail',
  doctype: DOCTYPES.UOM,
  homeName: 'uom',
  path: 'uom',
  views: {
    create: async () => await import('@/components/viewsExternal/UOM/AddUOM.vue'),
    detail: async () => await import('@/components/viewsExternal/UOM/ViewUOM.vue'),
    list: async () => await import('@/components/viewsExternal/UOM/UOMView.vue'),
  },
})

export { routeUOMCreate, routeUOMDetail, routeUOMHome, routeUOMRoot }
